export default __webpack_public_path__ + "static/DisplayHDR-500-TrueBlack-992f6c4a0b0ad0068ee9389ed58cfb50.png";